module.exports = "//static.hsappstatic.net/audio-components/static-1.3048/assets/voice-samples/alloy.mp3"